import { useEffect, useState } from "react";
import { CalendarX } from "lucide-react";
import { getBlockedDates } from "@/lib/api";
import { formatRange, isPastRange } from "@/lib/dates";

export const BookedDates = ({ propertySlug }) => {
  const [ranges, setRanges] = useState([]);

  useEffect(() => {
    getBlockedDates(propertySlug)
      .then((r) => setRanges(r.data.filter((x) => !isPastRange(x.end))))
      .catch(() => setRanges([]));
  }, [propertySlug]);

  if (!ranges.length) return null;

  return (
    <div className="mt-8 border border-[#B08A3E]/40 bg-[#F2EBDD] p-6 md:p-8" data-testid="booked-dates">
      <h3 className="flex items-center gap-3 font-display text-2xl text-[#0F2A52]">
        <CalendarX size={18} className="text-[#B08A3E]" /> Dates already taken
      </h3>
      <p className="text-sm text-[#4A4A4A] leading-relaxed mt-3">
        These nights are booked. Everything else is open — send your dates and Robert will confirm.
      </p>
      <ul className="flex flex-wrap gap-3 mt-5">
        {ranges.map((r) => (
          <li
            key={r.id}
            className="border border-[#0F2A52]/15 bg-[#FCFAF6] px-4 py-2 text-sm text-[#0F2A52]"
            data-testid={`booked-range-${r.id}`}
          >
            {formatRange(r.start, r.end)}
            {r.note ? <span className="text-[#4A4A4A]"> · {r.note}</span> : null}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BookedDates;
